import React from "react";

export const FeaturesVoiceover = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={42}
            viewBox="0 0 24 42"
            fill="none"
            {...props}
        >
            <rect
                x={5.5}
                y={0.887207}
                width={13}
                height={25}
                rx={6.5}
                stroke="#32393E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.043 16.387v3.31c0 6.4 4.906 11.587 10.957 11.587 6.051 0 10.956-5.188 10.956-11.586v-3.31H24v3.31c0 7.008-5.373 12.69-12 12.69S0 26.705 0 19.697v-3.31h1.043z"
                fill="#32393E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 5.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 8.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 11.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 14.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 17.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5zM7.5 20.887a.5.5 0 01.5-.5h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5z"
                fill="#FE9235"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 41.387c-.552 0-1-.186-1-.416v-9.167c0-.23.448-.417 1-.417s1 .187 1 .417v9.167c0 .23-.448.416-1 .416zM.5 18.887a.5.5 0 01.5-.5h4.034a.5.5 0 010 1H1a.5.5 0 01-.5-.5zM18 18.887c0-.276.293-.5.654-.5h4.692c.361 0 .654.224.654.5s-.293.5-.654.5h-4.692c-.361 0-.654-.224-.654-.5z"
                fill="#32393E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 40.887c0-.276.241-.5.538-.5h12.924c.297 0 .538.224.538.5s-.241.5-.538.5H5.538c-.297 0-.538-.224-.538-.5z"
                fill="#32393E"
            />
        </svg>
    )
}
